import { useState, useEffect } from "react";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
import BannerImgDesk from "./../assets/NARASHIMABanner.webp";
import axios from "axios";
import img1 from "./../assets/narasimha/Narasimhaimg1.webp";
import img2 from "./../assets/narasimha/Narasimhaimg3.webp";
import img3 from "./../assets/narasimha/MahaKirtan.webp";
import img4 from "./../assets/narasimha/kathaimg3.webp";
import img5 from "./../assets/narasimha/Narasimhaimg.webp";
import { Helmet } from "react-helmet-async";

import AccountDetails from "../Components/AccountDetails";

function Narasimha() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    annadaanSeva: false,
    mahaYaganSeva: false,
    mahaNivedanaSeva: false,
    garlandSingharaSeva: false,
    mahaSankhabhisekhamSeva: false,
    mandirAlnkarnaSeva: false,

    sevaDate: "",
    honoureeName: "",
    relationship: "",
    donorName: "",
    email: "",
    mobile: "",
    dob: "",
    receive80G: false,
    panNumber: "",
    receiveMahaPrasadam: false,

    selectedAnnadaanAmount: false,
    selectedMahaYaganAmount: false,
    selectedMahaNivedanaAmount: false,
    selectedGarlandSingharaAmount: false,
    selectedMahaSankhabhisekhamAmount: false,
    selectedMandirAlnkarnaAmount: false,

    customAnnadaanAmount: "",
    customMahaYaganAmount: "",
    customMahaNivedanaAmount: "",
    customGarlandSingharaAmount: "",
    customMahaSankhabhisekhamAmount: "",
    customMandirAlnkarnaAmount: "",

    mahaPrasadamDetails: {
      doorNumber: "",
      houseName: "",
      streetName: "",
      area: "",
      country: "",
      state: "",
      city: "",
      pincode: "",
    },
  });

  const [errors, setErrors] = useState({});
  const [show80GDetails, setShow80GDetails] = useState(false);
  const [showMahaPrasadamDetails, setShowMahaPrasadamDetails] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "customAnnadaanAmount" && value) {
        updatedData.selectedAnnadaanAmount = parseFloat(value);
      } else if (name === "customMahaYaganAmount" && value) {
        updatedData.selectedMahaYaganAmount = parseFloat(value);
      } else if (name === "customMahaNivedanaAmount" && value) {
        updatedData.selectedMahaNivedanaAmount = parseFloat(value);
      } else if (name === "customGarlandSingharaAmount" && value) {
        updatedData.selectedGarlandSingharaAmount = parseFloat(value);
      } else if (name === "customMahaSankhabhisekhamAmount" && value) {
        updatedData.selectedMahaSankhabhisekhamAmount = parseFloat(value);
      } else if (name === "customMandirAlnkarnaAmount" && value) {
        updatedData.selectedMandirAlnkarnaAmount = parseFloat(value);
      }

      return updatedData;
    });
  };

  const handle80GCheckboxChange = (e) => {
    setShow80GDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleMahaPrasadamCheckboxChange = (e) => {
    setShowMahaPrasadamDetails(e.target.checked);
    handleInputChange(e);
  };

  const handleAmountSelect = (section, amount) => {
    setFormData((prevData) => {
      switch (section) {
        case "annadaan":
          return {
            ...prevData,
            selectedAnnadaanAmount:
              prevData.selectedAnnadaanAmount === amount ? null : amount,
            customAnnadaanAmount: "",
          };
        case "MahaYagan":
          return {
            ...prevData,
            selectedMahaYaganAmount:
              prevData.selectedMahaYaganAmount === amount ? null : amount,
            customMahaYaganAmount: "",
          };
        case "MahaNivedana":
          return {
            ...prevData,
            selectedMahaNivedanaAmount:
              prevData.selectedMahaNivedanaAmount === amount ? null : amount,
            customMahaNivedanaAmount: "",
          };
        case "GarlandSinghara":
          return {
            ...prevData,
            selectedGarlandSingharaAmount:
              prevData.selectedGarlandSingharaAmount === amount ? null : amount,
            customGarlandSingharaAmount: "",
          };
        case "MahaSankhabhisekham":
          return {
            ...prevData,
            selectedMahaSankhabhisekhamAmount:
              prevData.selectedMahaSankhabhisekhamAmount === amount
                ? null
                : amount,
            customMahaSankhabhisekhamAmount: "",
          };
        case "MandirAlnkarna":
          return {
            ...prevData,
            selectedMandirAlnkarnaAmount:
              prevData.selectedMandirAlnkarnaAmount === amount ? null : amount,
            customMandirAlnkarnaAmount: "",
          };

        default:
          return prevData;
      }
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.donorName) newErrors.donorName = "Donor name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.mobile) newErrors.mobile = "Mobile number is required";
    if (!formData.dob) newErrors.dob = "Date of birth is required";
    if (formData.receive80G && !formData.panNumber)
      newErrors.panNumber = "PAN number is required for 80G certificate";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getTotalAmount = () => {
    const annadaanAmount =
      formData.selectedAnnadaanAmount ||
      parseFloat(formData.customAnnadaanAmount) ||
      0;
    const mahaYaganAmount =
      formData.selectedMahaYaganAmount ||
      parseFloat(formData.customMahaYaganAmount) ||
      0;
    const mahaNivedanaAmount =
      formData.selectedMahaNivedanaAmount ||
      parseFloat(formData.customMahaNivedanaAmount) ||
      0;
    const garlandSingharaAmount =
      formData.selectedGarlandSingharaAmount ||
      parseFloat(formData.customGarlandSingharaAmount) ||
      0;
    const mahaSankhabhisekhamAmount =
      formData.selectedMahaSankhabhisekhamAmount ||
      parseFloat(formData.customMahaSankhabhisekhamAmount) ||
      0;
    const mandirAlnkarnaAmount =
      formData.selectedMandirAlnkarnaAmount ||
      parseFloat(formData.customMandirAlnkarnaAmount) ||
      0;

    return (
      annadaanAmount +
      mahaYaganAmount +
      mahaNivedanaAmount +
      garlandSingharaAmount +
      mahaSankhabhisekhamAmount +
      mandirAlnkarnaAmount
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const totalAmount = getTotalAmount();
    let isFormDataStored = false;

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/payment/create-order`,
        {
          amount: totalAmount,
          currency: "INR",
        },
      );

      const order = response.data;
      let sevaDescription = "Donation Payment";

      const options = {
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: totalAmount * 100,
        currency: "INR",
        name: "ISKCON Narasimha chaturdashi Donation",
        description: sevaDescription,
        order_id: order.id,
        notes: {
          donorName: formData.donorName,
          donorPhoneNumber: formData.mobile,
          donorEmail: formData.email,
        },
        handler: async function (response) {
          try {
            const verificationResponse = await axios.post(
              `${process.env.REACT_APP_API_URL}/api/payment/verify-payment`,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                donationDetails: { ...formData, amount: totalAmount },
              },
            );

            if (verificationResponse.data.success) {
              alert("Payment Successful!");
              if (!isFormDataStored) {
                await storeFormData("Payment Successful");
                isFormDataStored = true;
              }
            }
          } catch (err) {
            console.error(err);
            alert("Payment verification failed");
            if (!isFormDataStored) {
              await storeFormData("Payment Failed");
              isFormDataStored = true;
            }
          }
        },
        prefill: {
          name: formData.donorName,
          email: formData.email,
          contact: formData.mobile,
        },
        theme: { color: "#C61D21" },
      };

      const paymentObject = new window.Razorpay(options);
      paymentObject.open();

      paymentObject.on("payment.failed", async function (response) {
        alert("Payment Failed: " + response.error.description);
        if (!isFormDataStored) {
          await storeFormData("Payment Failed");
          isFormDataStored = true;
        }
      });
    } catch (error) {
      console.error("Error initiating payment:", error);
      alert("Failed to initiate payment. Please try again.");
      if (!isFormDataStored) {
        await storeFormData("Payment Failed");
        isFormDataStored = true;
      }
    }
  };

  const storeFormData = async (paymentStatus) => {
    const totalDonationAmount = getTotalAmount();

    // Prepare data in the format expected by your Apps Script
    const formDataToSend = new URLSearchParams();

    // Add all fields to the form data
    formDataToSend.append("paymentStatus", paymentStatus);

    formDataToSend.append("annadaanSeva", formData.annadaanSeva ? "Yes" : "No");
    formDataToSend.append(
      "annadaanAmount",
      formData.selectedAnnadaanAmount || formData.customAnnadaanAmount || 0,
    );
    formDataToSend.append(
      "mahaYaganSeva",
      formData.mahaYaganSeva ? "Yes" : "No",
    );
    formDataToSend.append(
      "mahaYaganAmount",
      formData.selectedMahaYaganAmount || formData.customMahaYaganAmount || 0,
    );
    formDataToSend.append(
      "mahaNivedanaSeva",
      formData.mahaNivedanaSeva ? "Yes" : "No",
    );
    formDataToSend.append(
      "mahaNivedanaAmount",
      formData.selectedMahaNivedanaAmount ||
        formData.customMahaNivedanaAmount ||
        0,
    );
    formDataToSend.append(
      "garlandSingharaSeva",
      formData.garlandSingharaSeva ? "Yes" : "No",
    );
    formDataToSend.append(
      "garlandSingharaAmount",
      formData.selectedGarlandSingharaAmount ||
        formData.customGarlandSingharaAmount ||
        0,
    );
    formDataToSend.append(
      "mahaSankhabhisekhamSeva",
      formData.mahaSankhabhisekhamSeva ? "Yes" : "No",
    );
    formDataToSend.append(
      "mahaSankhabhisekhamAmount",
      formData.selectedMahaSankhabhisekhamAmount ||
        formData.customMahaSankhabhisekhamAmount ||
        0,
    );
    formDataToSend.append(
      "mandirAlnkarnaSeva",
      formData.mandirAlnkarnaSeva ? "Yes" : "No",
    );
    formDataToSend.append(
      "mandirAlnkarnaAmount",
      formData.selectedMandirAlnkarnaAmount ||
        formData.customMandirAlnkarnaAmount ||
        0,
    );

    formDataToSend.append("totalDonationAmount", totalDonationAmount);
    formDataToSend.append("sevaDate", formData.sevaDate || "");
    formDataToSend.append("honoureeName", formData.honoureeName || "");
    formDataToSend.append("relationship", formData.relationship || "");
    formDataToSend.append("donorName", formData.donorName);
    formDataToSend.append("email", formData.email);
    formDataToSend.append("mobile", formData.mobile);
    formDataToSend.append("dob", formData.dob);
    formDataToSend.append("receive80G", formData.receive80G ? "Yes" : "No");
    formDataToSend.append(
      "panNumber",
      formData.receive80G ? formData.panNumber : "",
    );
    formDataToSend.append(
      "receiveMahaPrasadam",
      formData.receiveMahaPrasadam ? "Yes" : "No",
    );
    formDataToSend.append(
      "doorNumber",
      formData.mahaPrasadamDetails.doorNumber || "",
    );
    formDataToSend.append(
      "houseName",
      formData.mahaPrasadamDetails.houseName || "",
    );
    formDataToSend.append(
      "streetName",
      formData.mahaPrasadamDetails.streetName || "",
    );
    formDataToSend.append("area", formData.mahaPrasadamDetails.area || "");
    formDataToSend.append(
      "country",
      formData.mahaPrasadamDetails.country || "",
    );
    formDataToSend.append("state", formData.mahaPrasadamDetails.state || "");
    formDataToSend.append("city", formData.mahaPrasadamDetails.city || "");
    formDataToSend.append(
      "pincode",
      formData.mahaPrasadamDetails.pincode || "",
    );

    try {
      const response = await fetch(
        "https://script.google.com/macros/s/AKfycbzFoA7Dg-Igqgd9GqEEqK-YB4k76MTJ8nUw0HuDuEVFKyMRkrQqH03FiDVPbKetm53SJQ/exec",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: formDataToSend.toString(),
        },
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      console.log("Data stored successfully in Google Sheets");
      return true;
    } catch (error) {
      console.error("Error storing data:", error);
      alert(
        "An error occurred while storing your donation details. Please try again.",
      );
      return false;
    }
  };
  const EventCard = ({ Image, title, fullWidth = false }) => (
    <div
      className={`bg-white  rounded-lg overflow-hidden shadow-lg transition-transform duration-300 hover:scale-105 ${
        fullWidth ? "md:col-span-2" : ""
      }`}
    >
      {/* Image container - full width with increased height */}
      <div className="w-full h-64 overflow-hidden">
        {" "}
        {/* Changed from h-48 to h-64 */}
        <img src={Image} alt="" className="w-full h-full object-cover" />
      </div>

      {/* Title with red background - reduced padding */}
      <div className="p-2 bg-[#C61D21] h-full">
        {" "}
        {/* Changed from p-4 to p-2 */}
        <h3 className="text-lg font-bold text-center text-white">{title}</h3>
      </div>
    </div>
  );

  const eventHighlights = [
    {
      Image: img1,
      title: "Sri Sudarshana Narasimha Maha Yajna",
    },
    {
      Image: img2,
      title: "Maha Shankha Abhishekam",
    },
    {
      Image: img3,
      title: "Maha Kirtan",
    },
    {
      Image: img4,
      title: "Narasimha Katha Pravachan",
    },
    {
      Image: img5,
      title: "Maha Annadaan",
      fullWidth: false,
    },
  ];

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const [copiedText, setCopiedText] = useState(null);
  const copyToClipboard = async (text, id) => {
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(text);
        setCopiedText(id);
        setTimeout(() => setCopiedText(null), 2000);
      } else {
        alert("Copy functionality is not supported in this browser.");
      }
    } catch (error) {
      console.error("Failed to copy text: ", error);
      alert("Failed to copy. Please try again.");
    }
  };

  return (
    <>
      <Helmet>
        <title>
          Narasimha Chaturdashi 2026 – Significance, Puja, and Celebrations |
          ISKCON Vijayawada
        </title>
        <meta
          name="description"
          content="Celebrate Narasimha Chaturdashi 2026 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta
          name="keywords"
          content="ISKCON Vijayawada Narasimha Chaturdashi, Narasimha Chaturdashi ISKCON Vijayawada, Narasimha Jayanti ISKCON, Narasimha Chaturdashi celebrations at ISKCON Vijayawada, Narasimha Chaturdashi pooja ISKCON Vijayawada, ISKCON Vijayawada festivals, Lord Narasimha festival ISKCON, Narasimha Chaturdashi 2026 ISKCON, Narasimha Jayanti 2026 Vijayawada, Narasimha Chaturdashi puja ISKCON Vijayawada, Lord Narasimha appearance day ISKCON, Narasimha Chaturdashi ritual Vijayawada, ISKCON spiritual events Vijayawada, Narasimha Chaturdashi significance ISKCON, Narasimha avatar celebration ISKCON"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="ISKCON Vijayawada" />
        <meta
          property="og:title"
          content="Narasimha Chaturdashi 2026 – Significance, Puja, and Celebrations | ISKCON Vijayawada"
        />
        <meta
          property="og:description"
          content="Celebrate Narasimha Chaturdashi 2026 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content=" https://www.iskconvijayawada.org/NarasimhaChaturdashi "
        />
        <meta
          property="og:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Narasimha Chaturdashi 2026 – Significance, Puja, and Celebrations | ISKCON Vijayawada"
        />
        <meta
          name="twitter:description"
          content="Celebrate Narasimha Chaturdashi 2026 with ISKCON Vijayawada! Discover the significance of Lord Narasimhadeva’s appearance, puja rituals, and how to participate in the festival."
        />
        <meta
          name="twitter:image"
          content="https://www.iskconvijayawada.org/static/media/logo.467e4780dde7b11ae4cf.png"
        />

        {/* Canonical URL */}
        <link
          rel="canonical"
          href="https://www.iskconvijayawada.org/NarasimhaChaturdashi"
        />
      </Helmet>

      <Header />
      <div className="font-[Open_Sans,sans-serif]">
        <div>
          <img
            loading="lazy"
            src={BannerImgDesk}
            alt="main Img"
            className="w-full block md:mt-[45px]"
          />
        </div>
        <div className="bg-cover bg-center pt-6">
          <div className="relative z-[2] text-center w-full px-[5%] box-border">
            <h2 className="text-[#c61d21] font-bold tracking-wide my-4 pt-2 text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
              Sri Narasimha Chaturdashi, 2026
            </h2>

            <h2 className="font-bold text-white py-1 px-4 bg-[#c61d21] border-2 border-white border-t-0 mx-auto my-6 rounded-b-xl max-w-[95%] text-center text-sm sm:text-base md:text-xl lg:text-2xl sm:px-6 md:px-10">
              Celebrate Narasimha Chaturdashi 2026 at ISKCON Vijayawada
            </h2>
            <div className="flex justify-center w-full px-2 sm:px-4 mb-10">
              <div className="w-full max-w-5xl text-justify text-[#333] leading-relaxed px-2 sm:px-4 [&>p]:mb-4 [&>p]:text-sm sm:[&>p]:text-base md:[&>p]:text-lg">
                <p>
                  Celebrate the auspicious appearance day of Lord Narasimha on
                  Narasimha Chaturdashi with ISKCON Vijayawada by becoming an
                  active part of the sacred Maha Yagna. This powerful festival
                  represents the victory of devotion over adversity, where the
                  Lord appeared to protect His devotee Prahlada and destroy all
                  negativity. Participating in this divine yagna helps purify
                  the mind, remove obstacles, and invite spiritual strength,
                  peace, and protection into one’s life.
                </p>
                <p>
                  By contributing ₹2116/- in any seva, you get a blessed
                  opportunity to be part of this sacred offering and receive the
                  special mercy of Lord Narasimha. You can participate both
                  online and offline, making it easy for everyone to be involved
                  in this divine celebration. Your seva supports a greater
                  spiritual cause while bringing blessings to you and your
                  family. Don’t miss this rare chance, step forward with faith
                  and experience divine grace.
                </p>
              </div>
            </div>
          </div>

          <div className="flex flex-col xl:flex-row justify-between pb-4 px-3 sm:px-4 gap-6">
            {/* Event Highlights Cards - Left Side */}
            <div className="w-full xl:w-[55%] mb-8 xl:mb-0">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-center text-[#C61D21] mb-4 sm:mb-6">
                Festival Highlights
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {eventHighlights.map((event, index) => (
                  <EventCard
                    key={index}
                    Image={event.Image}
                    title={event.title}
                    fullWidth={event.fullWidth}
                  />
                ))}
              </div>
            </div>

            {/* Donation Form - Right Side */}
            <div className="w-full xl:w-[42%] xl:flex xl:justify-center xl:pt-14">
              <div className="bg-[#C61D21] py-6 px-3 sm:py-10 sm:px-4 rounded-2xl xl:rounded-3xl xl:h-full xl:p-8 w-full">
                <form onSubmit={handleSubmit} className="text-white">
                  <h2 className="text-center text-xl sm:text-2xl xl:text-4xl font-bold mb-2">
                    Donation Details
                  </h2>

                  <div className="flex flex-col gap-3 my-4 px-3">
                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="annadaanSeva"
                        checked={formData.annadaanSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Annadaan Seva
                    </label>
                    {formData.annadaanSeva && (
                      <div className="grid grid-cols-2 -mt-4">
                        {[5000, 3500, 2000, 1000].map((amount) => (
                          <button
                            className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                            type="button"
                            key={amount}
                            onClick={() =>
                              handleAmountSelect("annadaan", amount)
                            }
                            style={{
                              backgroundColor:
                                formData.selectedAnnadaanAmount === amount
                                  ? "#fac785"
                                  : "",
                              margin: "5px",
                            }}
                          >
                            ₹ {amount.toLocaleString("en-IN")}
                          </button>
                        ))}
                        <input
                          type="number"
                          name="customAnnadaanAmount"
                          placeholder="₹ Enter Amount"
                          value={formData.customAnnadaanAmount || ""}
                          onChange={handleInputChange}
                          className="col-span-2 p-3 border rounded-xl my-1 mx-1 bg-white text-black"
                        />
                      </div>
                    )}

                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="mahaYaganSeva"
                        checked={formData.mahaYaganSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Maha Yagan Seva
                    </label>
                    {formData.mahaYaganSeva && (
                      <div className="grid grid-cols-2 -mt-4">
                        {[15000, 10000, 5000, 2116].map((amount) => (
                          <button
                            className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                            type="button"
                            key={amount}
                            onClick={() =>
                              handleAmountSelect("MahaYagan", amount)
                            }
                            style={{
                              backgroundColor:
                                formData.selectedMahaYaganAmount === amount
                                  ? "#fac785"
                                  : "",
                              margin: "5px",
                            }}
                          >
                            ₹ {amount.toLocaleString("en-IN")}
                          </button>
                        ))}
                        <input
                          type="number"
                          name="customMahaYaganAmount"
                          placeholder="₹ Enter Amount"
                          value={formData.customMahaYaganAmount || ""}
                          onChange={handleInputChange}
                          className="col-span-2 p-3 border rounded-xl my-1 mx-1 bg-white text-black"
                        />
                      </div>
                    )}

                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="mahaNivedanaSeva"
                        checked={formData.mahaNivedanaSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Maha Nivedana Seva
                    </label>
                    {formData.mahaNivedanaSeva && (
                      <div className="grid grid-cols-2 -mt-4">
                        {[8000, 4000, 2000, 1000].map((amount) => (
                          <button
                            className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                            type="button"
                            key={amount}
                            onClick={() =>
                              handleAmountSelect("MahaNivedana", amount)
                            }
                            style={{
                              backgroundColor:
                                formData.selectedMahaNivedanaAmount === amount
                                  ? "#fac785"
                                  : "",
                              margin: "5px",
                            }}
                          >
                            ₹ {amount.toLocaleString("en-IN")}
                          </button>
                        ))}
                        <input
                          type="number"
                          name="customMahaNivedanaAmount"
                          placeholder="₹ Enter Amount"
                          value={formData.customMahaNivedanaAmount || ""}
                          onChange={handleInputChange}
                          className="col-span-2 p-3 border rounded-xl my-1 mx-1 bg-white text-black"
                        />
                      </div>
                    )}

                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="garlandSingharaSeva"
                        checked={formData.garlandSingharaSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Garland Singhara Seva
                    </label>
                    {formData.garlandSingharaSeva && (
                      <div className="grid grid-cols-2 -mt-4">
                        {[5000, 3000, 2000, 1000].map((amount) => (
                          <button
                            className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                            type="button"
                            key={amount}
                            onClick={() =>
                              handleAmountSelect("GarlandSinghara", amount)
                            }
                            style={{
                              backgroundColor:
                                formData.selectedGarlandSingharaAmount ===
                                amount
                                  ? "#fac785"
                                  : "",
                              margin: "5px",
                            }}
                          >
                            ₹ {amount.toLocaleString("en-IN")}
                          </button>
                        ))}
                        <input
                          type="number"
                          name="customGarlandSingharaAmount"
                          placeholder="₹ Enter Amount"
                          value={formData.customGarlandSingharaAmount || ""}
                          onChange={handleInputChange}
                          className="col-span-2 p-3 border rounded-xl my-1 mx-1 bg-white text-black"
                        />
                      </div>
                    )}

                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="mahaSankhabhisekhamSeva"
                        checked={formData.mahaSankhabhisekhamSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Maha Sankhabhisekham Seva
                    </label>
                    {formData.mahaSankhabhisekhamSeva && (
                      <div className="grid grid-cols-2 -mt-4">
                        {[8000, 4000, 2000, 1000].map((amount) => (
                          <button
                            className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                            type="button"
                            key={amount}
                            onClick={() =>
                              handleAmountSelect("MahaSankhabhisekham", amount)
                            }
                            style={{
                              backgroundColor:
                                formData.selectedMahaSankhabhisekhamAmount ===
                                amount
                                  ? "#fac785"
                                  : "",
                              margin: "5px",
                            }}
                          >
                            ₹ {amount.toLocaleString("en-IN")}
                          </button>
                        ))}
                        <input
                          type="number"
                          name="customMahaSankhabhisekhamAmount"
                          placeholder="₹ Enter Amount"
                          value={formData.customMahaSankhabhisekhamAmount || ""}
                          onChange={handleInputChange}
                          className="col-span-2 p-3 border rounded-xl my-1 mx-1 bg-white text-black"
                        />
                      </div>
                    )}

                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="mandirAlnkarnaSeva"
                        checked={formData.mandirAlnkarnaSeva}
                        onChange={handleInputChange}
                        style={{ accentColor: "blue" }}
                      />
                      Mandir Alnkarna Seva
                    </label>

                    {formData.mandirAlnkarnaSeva && (
                      <div className="grid grid-cols-2 -mt-4">
                        {[5000, 3000, 2000, 1000].map((amount) => (
                          <button
                            className="col-span-1 font-semibold p-3 bg-[#F9E7D0] rounded-xl text-black"
                            type="button"
                            key={amount}
                            onClick={() =>
                              handleAmountSelect("MandirAlnkarna", amount)
                            }
                            style={{
                              backgroundColor:
                                formData.selectedMandirAlnkarnaAmount === amount
                                  ? "#fac785"
                                  : "",
                              margin: "5px",
                            }}
                          >
                            ₹ {amount.toLocaleString("en-IN")}
                          </button>
                        ))}
                        <input
                          type="number"
                          name="customMandirAlnkarnaAmount"
                          placeholder="₹ Enter Amount"
                          value={formData.customMandirAlnkarnaAmount || ""}
                          onChange={handleInputChange}
                          className="col-span-2 p-3 border rounded-xl my-1 mx-1 bg-white text-black"
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex flex-col gap-3 my-4 px-1 sm:px-3">
                    <h3 className="text-center text-base sm:text-lg font-semibold">Personal Details</h3>
                    <label className="w-full">
                      <input
                        type="text"
                        name="donorName"
                        value={formData.donorName}
                        onChange={handleInputChange}
                        placeholder="Donor Name"
                        className="w-full mt-1 p-2 sm:p-3 rounded-lg text-black outline-none"
                      />
                      {errors.donorName && (
                        <span className="block -mt-2 ml-2">
                          {errors.donorName}
                        </span>
                      )}
                    </label>
                    <label className="w-full">
                      <input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        placeholder="Email ID"
                        className="w-full p-2 sm:p-3 rounded-lg text-black outline-none"
                      />
                      {errors.email && (
                        <span className="block -mt-2 ml-2">{errors.email}</span>
                      )}
                    </label>
                    <div className="flex gap-2">
                      <label className="flex-1">
                        <input
                          type="tel"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleInputChange}
                          placeholder="Mobile Number"
                          className="w-full p-2 sm:p-3 rounded-lg text-black outline-none"
                        />
                        {errors.mobile && (
                          <span className="block mt-1 ml-2">
                            {errors.mobile}
                          </span>
                        )}
                      </label>
                      <label className="flex-1">
                        <input
                          type="text"
                          name="dob"
                          value={formData.dob}
                          onChange={handleInputChange}
                          className="w-full p-2 sm:p-3 rounded-lg text-[#909192] border outline-none"
                          placeholder="Date Of Birth"
                          onFocus={(e) => (e.target.type = "date")}
                          onBlur={(e) => (e.target.type = "text")}
                        />
                        {errors.dob && (
                          <span className="block -mt-2 ml-2">{errors.dob}</span>
                        )}
                      </label>
                    </div>
                  </div>
                  <p className="text-white mt-2 text-[10px]">
                    (Sankalpa and Archana will be performed for you on your
                    birthday)
                  </p>

                  <p className="text-white -mt-2 text-xs">
                    By continuing, you are agreeing to{" "}
                    <a className="underline text-[#EEF9A3]">
                      Terms of Use and Privacy Policy
                    </a>
                  </p>

                  <div className="px-1 sm:px-3 mt-6 flex flex-col gap-3">
                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="receive80G"
                        checked={formData.receive80G}
                        onChange={handle80GCheckboxChange}
                        style={{ accentColor: "blue" }}
                      />
                      I would like to receive 80(G) Certificate
                    </label>
                    {show80GDetails && (
                      <div className="mb-3 flex flex-col gap-2">
                        <p className="text-white text-[10px] text-left ml-2">
                          Finance Act 2021 mandates uploading donation details
                          for 80(G) deductions. Ensure PAN and address details
                          are provided.
                        </p>
                        <input
                          type="text"
                          name="panNumber"
                          value={formData.panNumber}
                          onChange={handleInputChange}
                          placeholder="Pan Number *"
                          className="w-full bg-white text-black px-3 py-2 sm:px-4 rounded-lg outline-none focus:ring-2 focus:ring-yellow-400 mt-1"
                          required
                        />
                        <input
                          type="text"
                          name="doorNumber"
                          placeholder="Door Number"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          value={formData.mahaPrasadamDetails.doorNumber}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                doorNumber: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="houseName"
                          placeholder="House / Apartment / Building Name"
                          value={formData.mahaPrasadamDetails.houseName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                houseName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="streetName"
                          placeholder="Street Name"
                          value={formData.mahaPrasadamDetails.streetName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                streetName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="area"
                          placeholder="Location / Area"
                          value={formData.mahaPrasadamDetails.area}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                area: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="country"
                          placeholder="Country"
                          value={formData.mahaPrasadamDetails.country}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                country: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="state"
                          placeholder="State"
                          value={formData.mahaPrasadamDetails.state}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                state: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="city"
                          placeholder="City"
                          value={formData.mahaPrasadamDetails.city}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                city: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="pincode"
                          placeholder="Pincode"
                          value={formData.mahaPrasadamDetails.pincode}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                pincode: e.target.value,
                              },
                            }))
                          }
                        />
                      </div>
                    )}

                    <label className="bg-[#F9E7D0] text-black p-3 rounded-xl flex items-center gap-3 font-bold font-sans">
                      <input
                        type="checkbox"
                        name="receiveMahaPrasadam"
                        checked={formData.receiveMahaPrasadam}
                        onChange={handleMahaPrasadamCheckboxChange}
                        style={{ accentColor: "blue" }}
                      />
                      I would like to receive Maha prasadam (Only within India)
                    </label>
                    {showMahaPrasadamDetails && (
                      <div className="mt-3 flex flex-col gap-2">
                        <input
                          type="text"
                          name="doorNumber"
                          placeholder="Door Number"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          value={formData.mahaPrasadamDetails.doorNumber}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                doorNumber: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="houseName"
                          placeholder="House / Apartment / Building Name"
                          value={formData.mahaPrasadamDetails.houseName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                houseName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="streetName"
                          placeholder="Street Name"
                          value={formData.mahaPrasadamDetails.streetName}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                streetName: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="area"
                          placeholder="Location / Area"
                          value={formData.mahaPrasadamDetails.area}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                area: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="country"
                          placeholder="Country"
                          value={formData.mahaPrasadamDetails.country}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                country: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="state"
                          placeholder="State"
                          value={formData.mahaPrasadamDetails.state}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                state: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="city"
                          placeholder="City"
                          value={formData.mahaPrasadamDetails.city}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                city: e.target.value,
                              },
                            }))
                          }
                        />
                        <input
                          type="text"
                          className="w-full bg-white text-black px-3 py-2 rounded-lg outline-none"
                          name="pincode"
                          placeholder="Pincode"
                          value={formData.mahaPrasadamDetails.pincode}
                          onChange={(e) =>
                            setFormData((prev) => ({
                              ...prev,
                              mahaPrasadamDetails: {
                                ...prev.mahaPrasadamDetails,
                                pincode: e.target.value,
                              },
                            }))
                          }
                        />
                      </div>
                    )}
                  </div>

                  <div className="flex justify-center mt-8">
                    <button
                      type="submit"
                      className="bg-[#FAE29C] text-black px-12 py-3 rounded-2xl font-bold"
                    >
                      Donate{" "}
                      {getTotalAmount() > 0
                        ? "₹ " + getTotalAmount().toLocaleString("en-IN")
                        : ""}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="mx-3 sm:mx-6 mt-4 md:mt-0">
            <div className="text-left md:mx-44 pb-10">
              <h2 className="text-xl sm:text-2xl md:text-3xl text-[#C61D21] text-left font-bold">
                Note:
              </h2>
              <p className="text-sm sm:text-base md:text-xl lg:text-2xl text-black w-full text-justify font-semibold mt-2">
                Donors contributing <span className="text-red"> ₹2,116 </span>
                or more will be specially invited to sit in the sacred Sri
                Sudarshana Narasimha Maha Yajna — with options to participate
                both onsite at the temple or virtually from home
              </p>
            </div>
          </div>
          <AccountDetails />
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Narasimha;
